import { format, startOfWeek } from 'date-fns'

let now_ = new Date()

export const ISO_FORMAT = 'yyyy-MM-dd'
export const DEFAULT_DATE = format(now_, ISO_FORMAT)
export const FIRST_DAY_WEEK = format(startOfWeek(new Date()), ISO_FORMAT)
export const FIRST_DAY_MONTH = format(new Date(now_.getFullYear(), now_.getMonth(), 1), ISO_FORMAT)
export const FIRST_DAY_YEAR = format(new Date(now_.getFullYear(), 0, 1), ISO_FORMAT)
